import { ReactNode, useCallback } from 'react';

// Data
import { useIntlSnackbar } from './use-intl-snackbar';

// Components
import { IIntlMessage } from '../../components/_core/IntlMsg/intl-msg.types';

// The two halves of a failed operation in one call: the raw error to the console for
// debugging, and the caller's friendly message to the user as an error snackbar.
// A call may pass its own message (with `values`) when the failure is one it can name.
export const useOperationErrorHandler = (failureMessage: IIntlMessage) => {
  const showSnackbar = useIntlSnackbar();

  return useCallback((
    operation: string,
    error: unknown,
    specificFailure?: { message: IIntlMessage; values?: Record<string, ReactNode> }
  ) => {
    console.error(`${operation} failed:`, error);
    showSnackbar(specificFailure?.message || failureMessage, 'error', undefined, specificFailure?.values);
  }, [showSnackbar, failureMessage]);
};
